import { Tooltip } from "react-tooltip";

import styled from "@emotion/styled";

export const Text = styled.p`
  width: 95px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ReactTooltip = styled(Tooltip)`
  box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px !important;

  --rt-transition-show-delay: 0.3s;
  --rt-transition-closing-delay: 0.15s;
`;
